<template>
  <div>
    <section
      class="relative w-full min-h-[70vh] md:min-h-[85vh] lg:min-h-[95vh] bg-[url('/img/newseaton-hero-bg.png')] bg-[#80b7dd] bg-cover bg-top bg-no-repeat flex flex-col items-center pt-10 md:pt-16 lg:pt-20 font-sans">

      <img src="/img/bp-marketing-logo-w.png" alt="New Seaton"
        class="w-48 md:w-60 lg:w-[280px] mb-6 md:mb-10 object-contain drop-shadow-md" />

      <div class="text-center px-4 flex flex-col items-center w-full max-w-5xl railway-medium">

        <h1 class="text-white font-bold tracking-tight
           text-2xl leading-[1.1]
           md:text-4xl md:leading-[1.15] 
           lg:text-[42px] lg:leading-[1.05]">
          New Freehold Townhomes <br />
          & Detached Family Homes
        </h1>

        <div
          class="flex items-center justify-center text-[#E30033] font-bold leading-[1.1] md:leading-[1.15] lg:leading-[1.05]">
          <h1 class="font-bold tracking-tight
           text-2xl leading-[1.1] 
           md:text-4xl md:leading-[1.15] 
           lg:text-[42px] lg:leading-[1.05]">
            Now Selling
          </h1>

          <div
            class="flex flex-col justify-center items-center mx-2 md:mx-4 text-gray-800 font-bold uppercase tracking-wide text-[10px] md:text-[16px] lg:text-[20px] xl:text-[24px] leading-tight drop-shadow-none">
            <h6 class="mb-[0px] sm:mb-[-5px] text-[#E30033]  text-[10px] md:text-[16px] lg:text-[20px] xl:text-[24px]">From</h6>
            <h6 class="text-[#E30033]  text-[10px] md:text-[16px] lg:text-[20px] xl:text-[24px]">The Upper</h6>
          </div>

          <h1 class="font-bold tracking-tight
           text-2xl leading-[1.1] 
           md:text-4xl md:leading-[1.15] 
           lg:text-[42px] lg:leading-[1.05]">
            $600's
          </h1>
        </div>

        <h1 class="text-[#E30033] font-bold italic font-bold tracking-tight
           text-2xl leading-[1.1] 
           md:text-4xl md:leading-[1.15] 
           lg:text-[42px] lg:leading-[1.05] pb-[25rem] md:pb-[5rem]">
          At White's Rd. & Taunton Rd.
        </h1>

      </div>
    </section>

    <section class="relative w-full bg-white py-16 md:py-24 lg:py-32 overflow-hidden railway-medium">
      <div
        class="absolute inset-0 z-0 bg-[url('/img/background-1.png')] bg-cover bg-center bg-no-repeat opacity-60 pointer-events-none">
      </div>
      <div class="relative z-10 container mx-auto px-6 md:px-12 lg:px-16 max-w-[1300px]">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-10 items-center content-start">
          <div class="flex flex-col items-start justify-center">
            <h2
              class="text-[#1a1a1a] text-[32px] md:text-[42px] lg:text-[46px] font-bold uppercase leading-[1.1] mb-6 tracking-tight">
              Welcome To <br class="hidden sm:block" />
              Ontario's Largest <br class="hidden sm:block" />
              Master-Planned <br class="hidden sm:block" />
              Community
            </h2>
            <p class="text-black text-[16px] md:text-[18px] leading-[1.6] mb-8 lg:mb-10 max-w-[540px]">
              New Seaton invites you to discover a unique new neighbourhood setting unlike anywhere in the GTA—at North
              Pickering's most connected address. Now under construction with 42 community parks, 3,750 acres of trails,
              3 new elementary schools, and over 200 retailers planned throughout the neighbourhood, New Seaton is a
              true master-planned community where more than 70,000 residents will soon call home.
            </p>
            <a href="#visit-us"
              class="inline-block bg-[#222222] hover:bg-black text-white font-bold text-[16px] md:text-[18px] tracking-wide py-[10px] px-[25px] transition-colors duration-300">
              VISIT US TODAY
            </a>
          </div>
          <div class="w-full flex justify-center lg:justify-end">
            <img src="/img/community-walking.png" alt="Couple walking in New Seaton community"
              class="w-full max-w-[550px] lg:max-w-[600px] h-auto object-cover object-center shadow-sm" />
          </div>
        </div>
      </div>
    </section>

    <section class="w-full bg-[#1e1c1d] py-16 md:py-24 lg:py-28 font-sans railway-medium">
      <div class="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1200px]">

        <div
          class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-y-10 lg:gap-y-12 gap-x-5 auto-rows-max items-start content-start">

          <div class="flex flex-col items-center text-center">
            <img src="/img/amenity/6.png" alt="70,000+ Total Residents"
              class="h-[100px] md:h-[120px] lg:h-[150px] mb-1 md:mb-2 object-contain" />
            <p class="text-white font-semibold text-[17px] md:text-[19px] lg:text-[21px] leading-[1.25] tracking-wide">
              70,000+ <br />
              Total Residents
            </p>
          </div>

          <div class="flex flex-col items-center text-center">
            <img src="/img/amenity/5.png" alt="42 Dedicated Community Parks"
              class="h-[100px] md:h-[120px] lg:h-[150px] mb-1 md:mb-2 object-contain" />
            <p class="text-white font-semibold text-[17px] md:text-[19px] lg:text-[21px] leading-[1.25] tracking-wide">
              42 Dedicated <br />
              Community Parks
            </p>
          </div>

          <div class="flex flex-col items-center text-center">
            <img src="/img/amenity/4.png" alt="3,750 Acres of Walking & Cycling Trails"
              class="h-[100px] md:h-[120px] lg:h-[150px] mb-1 md:mb-2 object-contain" />
            <p class="text-white font-semibold text-[17px] md:text-[19px] lg:text-[21px] leading-[1.25] tracking-wide">
              3,750 Acres of Walking <br />
              & Cycling Trails
            </p>
          </div>

          <div class="flex flex-col items-center text-center">
            <img src="/img/amenity/3.png" alt="Over 200 New Shops & Essential Stores"
              class="h-[100px] md:h-[120px] lg:h-[150px] mb-1 md:mb-2 object-contain" />
            <p class="text-white font-semibold text-[17px] md:text-[19px] lg:text-[21px] leading-[1.25] tracking-wide">
              Over 200 New Shops <br />
              & Essential Stores
            </p>
          </div>

          <div class="flex flex-col items-center text-center">
            <img src="/img/amenity/2.png" alt="New Schools & Recreation Centres"
              class="h-[100px] md:h-[120px] lg:h-[150px] mb-1 md:mb-2 object-contain" />
            <p class="text-white font-semibold text-[17px] md:text-[19px] lg:text-[21px] leading-[1.25] tracking-wide">
              New Schools & <br />
              Recreation Centres
            </p>
          </div>

          <div class="flex flex-col items-center text-center">
            <img src="/img/amenity/1.png" alt="10 Mins To GO Transit, Hwys. 401 & 407"
              class="h-[100px] md:h-[120px] lg:h-[150px] mb-1 md:mb-2 object-contain" />
            <p class="text-white font-semibold text-[17px] md:text-[19px] lg:text-[21px] leading-[1.25] tracking-wide">
              10 Mins To GO Transit, <br />
              Hwys. 401 & 407
            </p>
          </div>

        </div>
      </div>
    </section>

    <section class="w-full bg-white pt-16 md:pt-24 lg:pt-28 pb-0 font-sans relative overflow-hidden">

      <!-- Text Content Container -->
      <div class="container mx-auto px-4 flex flex-col items-center text-center relative z-10">

        <!-- Main Headlines -->
        <h2
          class="text-[#1a1a1a] font-bold text-[26px] sm:text-[32px] md:text-[40px] lg:text-[46px] leading-[1.15] tracking-tight">
          New Freehold Townhomes <br />
          & Detached Family Homes
        </h2>

        <!-- Pricing Row -->
        <div class="flex items-center justify-center text-[#E30033] font-bold ">
          <span
            class="text-[26px] sm:text-[32px] md:text-[40px] lg:text-[46px] leading-[1.15] leading-none tracking-tight">
            Now Selling
          </span>

          <div
            class="flex flex-col justify-center items-center mx-2 md:mx-4 text-gray-800 font-bold uppercase tracking-wide text-[10px] md:text-sm leading-tight drop-shadow-none">
            <span class="mb-[-2px] sm:mb-[-5px]  text-[#E30033]">From</span>
            <span class="text-[#E30033]">The Upper</span>
          </div>

          <span
            class="text-[26px] sm:text-[32px] md:text-[40px] lg:text-[46px] leading-[1.15] leading-none tracking-tight">
            $600's
          </span>
        </div>
      </div>

      <!-- GIF/Image Container -->
      <!-- Note: Replacing the mockup's "GIF" placeholder text with the actual image tag -->
      <div
        class="w-full mt-10 md:mt-14 lg:mt-16 relative z-10 flex justify-center px-0 sm:px-4 md:px-0  pb-10 md:pb-14 lg:pb-16">
        <!-- <img src="/img/elevation.gif" alt="New Seaton Townhomes exterior rendering"
          class="w-full max-w-[1600px] h-auto object-cover block" /> -->
        <slick :options="slickOptionsFP" class="max-w-6xl mx-auto">
          <div v-for="(image, index) in galleryImagesFP" :key="index" class="px-2">
            <div class="h-[175px] md:h-[500px] lg:h-[480px] w-full bg-center bg-contain bg-no-repeat flex items-center justify-center"
              :style="{ backgroundImage: `url(${image})` }">
            </div>
          </div>
        </slick>
      </div>

    </section>
    <section
      class="w-full py-16 text-black bg-[url('/img/background-2.png')] bg-[length:70%] bg-left-bottom bg-no-repeat">
      <div class="container mx-auto px-4">
        <h2
          class="text-center text-[#1a1a1a] font-bold text-[26px] sm:text-[32px] md:text-[40px] lg:text-[46px] leading-[1.15] tracking-tight mb-[25px]">
          DESIGNER DECORATED MODEL HOMES TO TOUR
        </h2>

        <slick :options="slickOptions" class="max-w-6xl mx-auto">
          <div v-for="(image, index) in galleryImages" :key="index" class="px-2">
            <div class="md:h-[500px] h-[480px] w-full bg-center bg-cover bg-no-repeat flex items-center justify-center"
              :style="{ backgroundImage: `url(${image})` }">
            </div>
          </div>
        </slick>
        <!-- <div class="w-full mt-10 md:mt-14 lg:mt-16 relative z-10 flex justify-center px-0 sm:px-4 md:px-0  pb-10 md:pb-14 lg:pb-16">
          <img src="/img/interior.gif" alt="New Seaton Townhomes exterior rendering"
            class="w-full max-w-[1600px] h-auto object-cover block" />
        </div> -->
      </div>
    </section>

    <!-- Builders Section -->
    <section class="relative w-full bg-[#EBEBEB] py-16 md:py-24 lg:py-32 font-sans overflow-hidden">

      <!-- 
      Faint Background Graphic 
      Replace '/img/abstract-leaf-light.png' with your exported watermark shape.
    -->
      <div
        class="absolute inset-y-0 left-0 w-1/3 md:w-1/4 bg-[url('/img/abstract-leaf-light.png')] bg-no-repeat bg-left-top bg-contain opacity-60 pointer-events-none">
      </div>

      <div class="container mx-auto px-6 flex flex-col items-center text-center relative z-10 max-w-[1000px]">

        <!-- Main Headlines -->
        <h2
          class="text-[#111111] font-bold md:font-extrabold text-[36px] sm:text-[46px] md:text-[56px] lg:text-[64px] uppercase leading-[1.05] tracking-tight mb-2">
          Built From <br />
          The Ground Up
        </h2>

        <h3
          class="text-[#1a1a1a] text-[20px] sm:text-[24px] md:text-[28px] lg:text-[32px] font-medium tracking-tight mb-8 md:mb-10">
          By 3 Award-Winning Homebuilders
        </h3>

        <!-- Main Paragraph -->
        <p class="text-[#1a1a1a] text-[15px] sm:text-[16px] md:text-[18px] leading-[1.6] max-w-[850px] mb-8 md:mb-10">
          The visionary builders behind New Seaton combine industry-leading craftsmanship,
          exquisite architecture, unmatched interior décor, and decades of homebuilding
          expertise to offer exceptional family homes designed for your lifestyle.
        </p>

        <!-- Secondary Paragraph -->
        <p class="text-[#1a1a1a] text-[15px] sm:text-[16px] md:text-[18px] leading-[1.6] mb-14 md:mb-20">
          Learn More About New Seaton's <br class="hidden sm:block" />
          Acclaimed Builders & Browse Floor Plans Below
        </p>

        <!-- Logos Row -->
        <div class="flex flex-col md:flex-row items-center justify-center gap-14 md:gap-16 lg:gap-28 w-full">

          <!-- Brookfield Residential -->
          <div class="flex items-center justify-center w-48 md:w-56 lg:w-[300px]">
            <img src="/img/Brookfield-Logo-B.png" alt="Brookfield Residential" class="w-full h-auto object-contain" />
          </div>

          <!-- Aspen Ridge -->
          <div class="flex items-center justify-center w-36 md:w-44 lg:w-[240px]">
            <img src="/img/Aspenridge-Logo-B.png" alt="Aspen Ridge Homes" class="w-full h-auto object-contain" />
          </div>

          <!-- Tower Hill -->
          <div class="flex items-center justify-center w-48 md:w-56 lg:w-[300px]">
            <img src="/img/Towerhill-Logo-B.png" alt="TowerHill Homes" class="w-full h-auto object-contain" />
          </div>

        </div>

      </div>
    </section>

    <section id="register" class="bg-white md:py-32 py-16 text-black">
      <div class="container mx-auto px-4">
        <div class="text-center mb-14">
          <!-- <h2 class="text-2xl md:text-4xl font-bold">REGISTER TO BE FIRST</h2>
          <div class="w-full flex items-center justify-center">
            <p
              class="text-center text-[#1a1a1a] text-[12px] sm:text-[14px] md:text-[16px] lg:text-[16px] leading-[1.5] max-w-[850px]">
              Receive exclusive community updates, offers, and purchase opportunities on new homes <br
                class="hidden md:block" />
              in Ontario's largest master-planned community.
            </p>
          </div> -->
          <h2
            class="text-[#1a1a1a] text-[32px] md:text-[42px] lg:text-[46px] font-bold uppercase leading-[1.1] mb-6 tracking-tight">
            REGISTER TO BE FIRST
          </h2>
          <h3
            class="text-[#1a1a1a] text-[16px] sm:text-[20px] md:text-[24px] lg:text-[26px] font-medium tracking-tight mb-8 md:mb-10">
            Receive exclusive community updates, offers, and purchase opportunities on new homes <br
              class="hidden xl:block" />
            in Ontario's largest master-planned community.
          </h3>
        </div>

        <form class="mx-auto" @submit.prevent="submitForm">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <input v-model="form.firstName" type="text" placeholder="FIRST NAME*"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none" required />
            </div>
            <div>
              <input v-model="form.lastName" type="text" placeholder="LAST NAME*"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none" required />
            </div>

            <div>
              <input v-model="form.email" type="email" placeholder="EMAIL ADDRESS*"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none" required />
            </div>
            <div>
              <input v-model="form.phone" type="tel" placeholder="PHONE NUMBER*"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none" required />
            </div>

            <div>
              <input v-model="form.postalCode" type="text" placeholder="POSTAL CODE*"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none" required />
            </div>
            <div>
              <select v-model="form.buyerType"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none custom-select-arrow"
                required>
                <option value="" disabled>TYPE OF BUYER*</option>
                <option value="first-time">First-Time Buyer</option>
                <option value="move-up">Move-Up Buyer</option>
                <option value="downsize">Downsizer</option>
              </select>
            </div>

            <div>
              <input v-model="form.referral" type="text" placeholder="HOW DID YOU HEAR ABOUT US?*"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none" required />
            </div>
            <div>
              <select v-model="form.isRealtor"
                class="w-full bg-[#E6E6E6] px-4 py-3 text-sm md:text-base placeholder-black outline-none custom-select-arrow"
                required>
                <option value="" disabled>ARE YOU A REALTOR?*</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 items-start">
            <div class="flex items-start gap-2">
              <input v-model="form.consent" type="checkbox" id="consent"
                class="mt-1 w-4 h-4 cursor-pointer accent-black" required />
              <label for="consent" class="text-sm md:text-base leading-normal">
                By completing this registration form for New Seaton, I expressly
                provide my consent to receive electronic messages from New
                Seaton, and from the builders of New Seaton, retroactively,
                today and in the future and for any projects. I understand that
                I may withdraw my consent by unsubscribing at any time.
              </label>
            </div>

            <div class="flex md:justify-end md:mt-0">
              <button type="submit"
                class="inline-block bg-black text-white font-black py-3 px-20 mt-3 hover:bg-gray-800 transition-colors duration-300 md:text-2xl md:w-[400px] w-full">
                REGISTER NOW
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>

    <!-- Presentation Centre Footer Section -->
    <section id="visit-us" class="w-full bg-black py-16 md:py-20 lg:py-24 font-sans flex justify-center">
      <div
        class="w-full max-w-[1200px] px-6 lg:px-8 flex flex-col md:flex-row justify-between items-start gap-12 lg:gap-16 relative">

        <div class="flex flex-col justify-between w-full md:w-2/3 xl:w-3/5">

          <div
            class="flex flex-col gap-6 text-[#e98e36] font-extrabold tracking-wide text-base sm:text-lg lg:text-xl leading-snug">
            <div>
              <p class="uppercase railway font-extrabold">Presentation Centre</p>
              <p class="uppercase railway font-extrabold">2860 White's Road, Pickering</p>
            </div>

            <div>
              <p class="uppercase railway font-extrabold">Hours:</p>
              <p class="uppercase railway font-extrabold">Monday - Thursday: 11AM - 5PM</p>
              <p class="uppercase railway font-extrabold">Saturday &amp; Sunday: 11AM - 5PM</p>
            </div>
          </div>

          <div class="flex flex-wrap items-center gap-6 sm:gap-8 lg:gap-10 mt-12 lg:mt-16">
            <div class="h-[40px] w-[110px] sm:h-[65px] sm:w-[130px] lg:h-[55px] lg:w-[160px] shrink-0">
              <div class="min-h-[70px]">
                <img src="/img/aspen-logo-blk.png" alt="AspenRidge Homes" class="w-[200px] block" />
              </div>
            </div>
            <div class="h-[40px] w-[90px] sm:h-[45px] sm:w-[130px] lg:h-[55px] lg:w-[160px] shrink-0">
              <div class="min-h-[70px]">
                <img src="/img/bf-logo-blk.png" alt="Brookfield Residential" class="w-[200px] block" />
              </div>
            </div>
            <div class="h-[40px] w-[90px] sm:h-[45px] sm:w-[130px] lg:h-[55px] lg:w-[160px] shrink-0">
              <div class="min-h-[70px]">
                <img src="/img/towerhill-logo-blk.png" alt="TowerHill Homes" class="w-[200px] block" />
              </div>
            </div>
          </div>

          <div class="hidden md:block mt-24 text-[10px] text-[#888888] font-light tracking-wide">
            Renderings are artist's concept. Prices, terms and specifications subject to change without notice. E. &amp;
            O. E.
          </div>

        </div>

        <div class="w-full md:w-1/3 xl:w-2/5 flex md:justify-end flex-shrink-0 mt-10 md:mt-0">
          <div class="w-full max-w-[500px] aspect-[4/3] shrink-0">
            <img src="/img/ns-map-blk.png" alt="Presentation Centre Map" class="w-full mt-10 md:mt-0" />
          </div>
        </div>

        <div class="block md:hidden w-full mt-10 text-[9px] text-[#888888] font-light tracking-wide">
          Renderings are artist's concept. Prices, terms and specifications subject to change without notice. E. &amp;
          O. E.
        </div>

      </div>
    </section>

    <!-- dismiss from here. -->
    <!-- <section class="bg-black text-white py-20">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-12 items-center">
          <div class="flex flex-col md:col-span-9 items-center md:items-start justify-center">
            <div class="flex flex-wrap md:justify-start justify-center gap-10">
              <div class="text-left">
                <div class="min-h-[70px]">
                  <img src="/img/aspen-logo-blk.png" alt="AspenRidge Homes" class="w-[200px] block" />
                </div>
                <div class="mt-2">
                  <p class="font-black">Aspen Ridge</p>
                  <p>Saturday &amp; Sunday: 11am - 5 pm</p>
                  <p>Monday to Wednesday: 1pm - 6pm</p>
                  <p>Thursday &amp; Friday: By Appointment</p>

                  <p class="underline">
                    <a href="mailto:NSSales@aspenridgehomes.com" class="">
                      NSSales@aspenridgehomes.com
                    </a>
                  </p>
                </div>
              </div>

              <div class="text-left">
                <div class="min-h-[70px]">
                  <img src="/img/bf-logo-blk.png" alt="Brookfield Residential" class="w-[200px] block" />
                </div>
                <div class="mt-2">
                  <p class="font-black">Brookfield Residential</p>
                  <p>By Appointment Only</p>
                  <p class="underline">
                    <a href="mailto:newseaton@brookfieldrp.com">
                      newseaton@brookfieldrp.com
                    </a>
                  </p>
                </div>
              </div>

              <div class="text-left">
                <div class="min-h-[70px]">
                  <img src="/img/towerhill-logo-blk.png" alt="TowerHill Homes" class="w-[200px] block" />
                </div>
                <div class="mt-2">
                  <p class="font-black">Tower Hill</p>
                  <p>By Appointment only</p>
                  <p class="underline">
                    <a href="mailto:sales@towerhill.ca">
                      sales@towerhill.ca
                    </a>
                  </p>
                </div>
              </div>
            </div>

          </div>

          <div class="flex md:col-span-3 justify-center md:justify-end">
            <img src="/img/ns-map-blk.png" alt="Presentation Centre Map" class="w-full mt-10 md:mt-0" />
          </div>
        </div>
        <p class="text-xs opacity-70 mt-10 text-left">
          Renderings are artist’s concept. Prices, terms and specifications
          subject to change without notice. E. &amp; O. E.
        </p>
      </div>
    </section> -->
  </div>
</template>

<script>
import Slick from "vue-slick";
import jq from "jquery";

export default {
  layout: "blank",
  components: {
    Slick
  },
  data() {
    return {
      galleryImages: [
        // "/img/ns-community-gallery/gallery-1.jpg",
        // "/img/ns-community-gallery/gallery-2.jpg",
        // "/img/ns-community-gallery/gallery-3.jpg",
        // "/img/ns-community-gallery/gallery-4.jpg",
        // "/img/ns-community-gallery/gallery-5.jpg",
        // "/img/ns-community-gallery/gallery-6.jpg",
        // "/img/ns-community-gallery/gallery-7.jpg",
        // "/img/ns-community-gallery/gallery-8.jpg",
        // "/img/ns-community-gallery/gallery-9.jpg",
        // "/img/ns-community-gallery/gallery-10.jpg",
        // "/img/ns-community-gallery/gallery-11.jpg",
        // "/img/ns-community-gallery/gallery-12.jpg",
        // "/img/ns-community-gallery/gallery-13.jpg",
        // "/img/ns-community-gallery/gallery-14.jpg",
        // "/img/ns-community-gallery/gallery-15.jpg",
        // "/img/ns-community-gallery/gallery-16.jpg",
        // "/img/ns-community-gallery/gallery-17.jpg",
        // "/img/ns-community-gallery/gallery-18.jpg",
        // "/img/ns-community-gallery/gallery-19.jpg"
        "/img/model-tour/NewSeaton_Unit4_0006.jpg",
        "/img/model-tour/NewSeaton_Unit4_0012.jpg",
        "/img/model-tour/NewSeaton_Unit4_0019.jpg",
        "/img/model-tour/NewSeaton_Unit4_0039.jpg",
        "/img/model-tour/NewSeaton_Unit4_0051.jpg",
        "/img/model-tour/NewSeaton_Unit4_0056.jpg",
        "/img/model-tour/NewSeaton_Unit4_0079.jpg",
        "/img/model-tour/NewSeaton_Unit4_0088.jpg",
        "/img/model-tour/NewSeaton_Unit4_0097.jpg",
        "/img/model-tour/NewSeaton_Unit4_0118.jpg",
        "/img/model-tour/NewSeaton_Unit4_0135.jpg",
      ],
      galleryImagesFP: [
        "/img/fp-slider/fp-img1.jpg",
        "/img/fp-slider/fp-img2.jpg",
        "/img/fp-slider/fp-img3.jpg",
      ],
      slickOptionsFP: {
        dots: true,
        arrows: false,
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            // Tablet and down
            breakpoint: 1024,
            settings: {
              slidesToShow: 1
            }
          },
          {
            // Mobile
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },
      slickOptions: {
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            // Tablet and down
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          },
          {
            // Mobile
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        postalCode: "",
        buyerType: "",
        referral: "",
        isRealtor: "",
        consent: false
      }
    };
  },
  methods: {
    submitForm() {
      // Basic client-side check for the consent box
      if (!this.form.consent) {
        alert("Please consent before submitting.");
        return;
      }

      // Prepare data
      const formData = {
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        email: this.form.email,
        phone: this.form.phone,
        postalCode: this.form.postalCode,
        buyerType: this.form.buyerType,
        referral: this.form.referral,
        isRealtor: this.form.isRealtor
      };

      console.log("Submitting form:", formData);

      // jQuery AJAX request
      jq.ajax({
        method: "POST",
        url: "/php/register-form.php",
        crossDomain: true,
        data: formData,
        success: data => {
          console.log("Success:", data);
          // If you have a thank-you route
          this.$router.push("/thankyou");
        }
      }).done(msg => {
        console.log("Request done:", msg);
      });
    }
  },
  mounted() {
    // Add Tailwind CSS CDN dynamically
    if (!document.querySelector("#tailwindcdn-script")) {
      const script = document.createElement("script");
      script.id = "tailwindcdn-script";
      script.src = "https://cdn.tailwindcss.com";
      document.head.appendChild(script);
    }
  }
};
</script>

<style scoped lang="scss">
html,
body {
  scroll-behavior: smooth;
}
</style>
<style>
.slick-prev:before,
.slick-next:before {
  color: black !important;
}

/* Hide default arrows for cross-browser */
.custom-select-arrow {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Make the arrow grey using a data URI */
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg fill='%237e7e7e' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='M5.516 7.548l4.484 4.487 4.484-4.487'/></svg>");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  /* adjust to taste */
  background-size: 1.5rem;
  /* arrow size */
  padding-right: 2.5rem;
  /* extra right padding */
}

/* (Optional) Hide the IE arrow if you still support old IE or Edge Legacy */
select::-ms-expand {
  display: none;
}
</style>



Your Guidelines Advertising Inc chats aren’t used to improve our models. Gemini is AI and can make mistakes. Your
privacy & GeminiOpens in a new window
